document.addEventListener('DOMContentLoaded', () => {
  initDaFaqSection();
});

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.da-faq-section')) {
    initDaFaqSection(e.target);
  }
});

function initDaFaqSection(container = document) {
  const sections = container.querySelectorAll('.da-faq-section');

  sections.forEach(section => {
    const items = section.querySelectorAll('.da-fs-item');

    items.forEach(item => {
      // Check if already initialized to prevent double binding
      if (item.dataset.initialized) return;
      item.dataset.initialized = 'true';

      const header = item.querySelector('.da-fs-header');
      const content = item.querySelector('.da-fs-content');

      if (!header || !content) return;

      // Initialize open state if active by default
      if (item.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
        header.setAttribute('aria-expanded', 'true');
      }

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('active');

        // Close all other items in the same section
        const allItems = section.querySelectorAll('.da-fs-item');
        allItems.forEach(otherItem => {
          if (otherItem !== item && otherItem.classList.contains('active')) {
            otherItem.classList.remove('active');
            otherItem.querySelector('.da-fs-content').style.maxHeight = null;
            otherItem.querySelector('.da-fs-header').setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current item
        if (isOpen) {
          item.classList.remove('active');
          content.style.maxHeight = null;
          header.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
          header.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
}
